import { Card } from "../components/Card";
import { Spinner } from "../components/Spinner";
import { cn } from "../lib/utils";
import * as React from "react";
const Root = ({
  className,
  children
}) => /*#__PURE__*/React.createElement(Card, {
  size: "md",
  className: cn("flex flex-col gap-2", className)
}, children);
const Header = ({
  className,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: cn("space-y-0.5", className)
}, children);
const Title = ({
  className,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: cn("heading-sm", "text-foreground", className)
}, children);
const Subtitle = ({
  className,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: cn("text-sm", "text-muted-foreground", className)
}, children);
const Content = ({
  className,
  children,
  isLoading = false
}) => {
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start"
    }, /*#__PURE__*/React.createElement(Spinner, {
      size: "xs",
      variant: "dark"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn("flex flex-col gap-3", "text-foreground", className)
  }, children);
};
const Footer = ({
  className,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: cn("flex items-center gap-2", className)
}, children);
/**
 * A compact metric card surfacing a single value with a `title`, optional `subtitle`,
 * and a `content` slot for the figure (number, icon, trend), plus an `isLoading` state.
 * Use it on dashboards and overviews to highlight a key metric or KPI; for a
 * non-standard arrangement of the parts, compose them directly with `ComposableCard`
 * (Root, Header, Title, Subtitle, Content, Footer).
 *
 * @summary Compact single-metric card.
 */
export const ValueCard = ({
  title,
  subtitle,
  content,
  footer,
  isLoading = false,
  className
}) => {
  return /*#__PURE__*/React.createElement(Root, {
    className: className
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Title, null, title), subtitle && /*#__PURE__*/React.createElement(Subtitle, null, subtitle)), /*#__PURE__*/React.createElement(Content, {
    isLoading: isLoading
  }, content), footer && /*#__PURE__*/React.createElement(Footer, null, footer));
};
export const ComposableCard = {
  Root,
  Header,
  Title,
  Subtitle,
  Content,
  Footer
};
//# sourceMappingURL=ValueCard.js.map